// extracted by mini-css-extract-plugin
var _1 = "AITextGeneration-moduleAITextGeneration__e0XwN";
export { _1 as "AITextGeneration" }
